import React from 'react'
import {ActionContext} from "../ActionContextProvider";

export const useActionContext = () => React.useContext(ActionContext)